<template>
  <div class="salesmanIndex">  
    <mu-appbar class="XR-head" title="升级产品专区">
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
    </mu-appbar>  

    <!--
    <div class="bannerDiv">
      <router-link :to="bannerAd.AdLink"><img :src="bannerAd.AdImg" class="banner"></router-link>
    </div>
	-->

    <div class="pro-list">
      <div :class="'item'+ (index%2==0?' rigthmargin':'') " v-for="(productItem,index) in integralProductList" :key="productItem.ProductId">
        <div class="top">
          <router-link :to="'/salesman/ProductDetail?skuId='+ productItem.SkuId"><img :style="{height: imgHeight+'px'}" :src="productItem.DefaultImage?productItem.DefaultImage: IMGServer_URL+'/images/index-item-default.png'" class="pro-img"></router-link>
        </div>
        <div class="text">
          <div class="money">
            <p class="price">￥<span>{{productItem.SalePrice.toFixed(2)}}</span></p>
            <p class="del-price">￥{{productItem.Price.toFixed(2)}}</p>
          </div>
          <router-link :to="'/salesman/ProductDetail?skuId='+ productItem.SkuId"><p class="name">{{productItem.ProductName}}</p></router-link>
          <p class="buycount">{{productItem.SaleCount}}人已购买</p>
        </div>
    </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
	<XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
export default {
  data(){
    return {
      integralProductList:[],
      bannerAd:{},
      AdLeft:{},
      AdRight:{},
      NowSignInfo:{},
      TomorrowSignInfo:{},
      memberFinance:{},
      sWidth : document.documentElement.clientWidth,
      isLogin:false,
      imgHeight: 0,
      shareTitle:'旭日购商城',
      shareDesc:'',
      shareLinkUrl:'',
      shareImgUrl:'https://imgserver.xurigo.com/upload/images/product/2021/07/26/09441530f0733e-2841-4320-acb7-7266c3a3f5d1.png',
    }
  },
  mounted(){
    /*
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    */
    this.GetSalesmanProductList()
    this.getIntegralAdList()

    if (this.$store.state.user.SessionId) {
      this.isLogin =true
      this.getUserInfo();
    }
    this.imgHeight = this.sWidth*0.49  
  },
  methods:{
    getUserInfo(){      
      const ths = this;
      this.$post("/Shop/UserServer/GetUserInfo")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.initShare(res.Data.user_name);
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    initShare(username){
      var ths = this;
      this.$postBase(
        this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
        ).then(function(res) {
        if(!res.IsSuccess){
            //ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.Data.AppId, // 必填，公众号的唯一标识
                timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
                nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
                signature: res.Data.Sign, // 必填，签名，见附录1
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            ths.shareLinkUrl = "https://m.xurigo.com/H5Recommend.aspx?source_username=" + username;
            wx.ready(function () {              
                wx.onMenuShareTimeline({
                    title: ths.shareTitle, // 分享标题
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });

                wx.onMenuShareQQ({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });

                wx.onMenuShareAppMessage({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
                wx.onMenuShareQZone({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
            });
        }
      });
    },
    GoHistory(){
      this.$router.goBack()
    },
    getIntegralAdList(){
      const ths = this;
      this.$post("/Shop/AdServer/GetAdsByPage",{ClientType:2, pageId:'c741b55d87384efdb268a78900f91171'})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false
          
          for(var i = 0; i< res.Data.length;i++){
            if(res.Data[i].AdName == '积分商城banner广告'){
              ths.bannerAd = res.Data[i];
            }
            else if(res.Data[i].AdName == '积分商城横幅广告（左）'){
              ths.AdLeft = res.Data[i];
            }
            else if(res.Data[i].AdName == '积分商城横幅广告（右）'){
              ths.AdRight = res.Data[i];
            }
          }

          ths.$refs.XRtoast.hide()
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    GetSalesmanProductList(){
      const ths = this;
      this.$post("/Shop/SalesmanServer/GetSalesmanProductList", {pageIndex:1, pageSize: 1600})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false
          ths.integralProductList = res.Data.List
          ths.$refs.XRtoast.hide()
        } else {
		  res.Msg = "暂无上架商品"
          ths.$refs.XRPageTip.ShowEmpty(res.Msg)
		}
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    toBeOnline:function(){
      this.$refs.XRtoast.load('拼命开发中...',true);
    }
  }
}
</script>

<style>
.XR-head .mu-appbar{
  height: 46px;
  text-align: center;
}
.XR-head .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.XR-head .mu-appbar-title {
  font-size: 16px;
}
.XR-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.XR-head .title .title-text {
  margin: 0;
  line-height: 48px;
}
.salesmanIndex .banner
{
    width:100%;    
    display:block;
}
.salesmanIndex .ph-nav{
  padding:.8rem 0;
  background:white;
  overflow: hidden;
}
.salesmanIndex .pro-list { background:#EEEDEE;margin-top: 0.8rem;}
 .pro-list .item { width:49%; float:left; margin-bottom:5px; background:white;}
.salesmanIndex .pro-list .item.rigthmargin { margin-right:2%;}
.salesmanIndex .pro-list .item .top { position:relative;}
.salesmanIndex .pro-list .item .top img { width:100%; display:block;}
.salesmanIndex .pro-list .item .top .dk { position:absolute; top:4px; right:4px; color:red;   text-align:center;}
.salesmanIndex .pro-list .item .top .dk span { font-size:12px; display:block; height:14px; line-height:14px; font-weight:700;}
.salesmanIndex .pro-list .text { padding:0 5px;}
.salesmanIndex .pro-list .text .money { font-size:12px; overflow:hidden; margin:5px 0;} 
.salesmanIndex .pro-list .text .money .price { float:left;color:Red;  padding-left:5px; line-height:1.0rem;}
.salesmanIndex .pro-list .text .money .price span { font-size:16px; font-weight:700;}
.salesmanIndex .pro-list .text .money .del-price { float:left; color:#A0A0A0; text-decoration:line-through; margin-left:10px; line-height:18px;}
.salesmanIndex .pro-list .item .name {   width:100%; overflow:hidden; height:36px; line-height:18px; font-size:12px;}
.salesmanIndex .pro-list .item .buycount { margin-bottom:5px; width:100%; overflow:hidden; height:16px; text-align:right; color:#EF8367; line-height:16px; font-size:12px;}

      
.salesmanIndex .signin { height:70px; background:#F9CC9D; overflow:hidden;}
.salesmanIndex .signin .left { float:left;margin-left:5px;}
.salesmanIndex .signin .left .box-open { float:left; margin-top:6px; width:55px;}
.salesmanIndex .signin .left .info { float:left; margin-top:21px; margin-left:4px;}
.salesmanIndex .signin .left .info .desc { font-size:12px; overflow:hidden; }
.salesmanIndex .signin .left .info .desc .special { font-size:16px;line-height:16px; color:#FF0000; float:left;}
.salesmanIndex .signin .left .info .desc .normal { font-size:12px; line-height:14px; margin-left:5px; float:left;}
.salesmanIndex .signin .left .info .tip { font-size:12px; line-height:12px; margin-top:3px;}
.salesmanIndex .signin .right { float:right; margin-right:5px;}
.salesmanIndex .signin .right .signin-btn { float:left; margin-top:14px; width:46px;}
.salesmanIndex .signin .right .btn { float:left; margin-top:22px;margin-left:2px;}
.salesmanIndex .signin .right .btn .btn-text { font-size:12px;line-height:12px;}
.salesmanIndex .signin .right .btn .award { font-size:12px;line-height:12px; margin-top:6px;}  
</style>




// WEBPACK FOOTER //
// src/pages/salesman/salesmanProductIndex.vue